import { USER_SUMMARY_RECEIVED, USER_SUMMARY_UPDATED, USER_SUMMARY_UNLOADED } from './types';
import api from 'api';

export const userSummaryReceived = (user_summary) => ({
  type: USER_SUMMARY_RECEIVED,
  user_summary
})

export const userSummaryUpdated = (lastAssessment) => ({
  type: USER_SUMMARY_UPDATED,
  lastAssessment
})

export const summaryUnloaded = data => ({
  type: USER_SUMMARY_UNLOADED
})

export const unloadSummary = () => dispatch => {
  dispatch(summaryUnloaded())
}

export const getLastAssessment = (planID) => (dispatch) =>
  api.bmc.dashboard.getLastAssessment(planID).then( lastAssessment => {
    dispatch(userSummaryUpdated(lastAssessment))
})

export const getUserSummary = () => (dispatch) =>
  api.bmc.dashboard.getUserSummary().then( user_summary => {
    dispatch(userSummaryReceived(user_summary))
})

